/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DictionaryResponse } from './dictionary-response';


export interface UserByIdResponse { 
    id: string;
    lastName: string;
    firstName: string;
    telegramLogin: string;
    email: string;
    roleId: string;
    status: DictionaryResponse;
}

